export default __webpack_public_path__ + "static/media/Daily_Stats_Template.eb871f15.xlsx";